module.exports = __webpack_public_path__ + "img/logo.96a20cfc.png";